// extracted by mini-css-extract-plugin
export default {"faceEmoji":"Dg5e8","face":"zt_Gu","features":"LUolg"};